import EXAMPLE from "../../assets/images/example.png";
import React, { Component } from "react";
import Swal from "sweetalert2";
import Switch from "react-switch";
import Navbar from "../../components/Navbar.js";
import { Modal, Toast } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { NumericFormat } from "react-number-format";
import * as XLSX from "xlsx";
import {
  profile,
  project,
  alert,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  DatePicker,
  Status,
  loading,
  toFixed,
  total,
  float,
  BtnIcon,
} from "../../components/CustomComponent.js";
import {
  report_cash_flow_report_table,
  report_cash_flow_report_full,
} from "../../components/Report.js";
import { stripJuristic } from "../../components/text-sanitize.js";
import Pagination from "@mui/material/Pagination";
import Resizer from "react-image-file-resizer";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
var title_data = {
  prev_balance_bank: {
    title: "สรุปยอดบัญชีเงินฝากธนาคารและเงินสดคงเหลือในมือยกมา",
    creatable: true,
    selected: true,
  },
  prev_balance_cash: {
    title: "รายการเงินสดคงเหลือในมือและอื่นๆ",
    creatable: true,
    selected: true,
  },

  income_received: { title: "รายการรับเงิน", creatable: true, selected: true },
  other_income: { title: "รายรับอื่นๆ", creatable: true, selected: true },
  deduction_amount: {
    title: "หัก/เพิ่ม/ลดหนี้",
    creatable: true,
    selected: true,
  },
  expense_amount: { title: "รายการจ่ายเงิน", creatable: true, selected: true },
  bank_deposit_balance: {
    title: `ยอดเงินฝากธนาคาร ${project?.project_name || "ผู้ดูแลระบบ"}`,
    creatable: true,
    selected: true,
  },
  cash_deposit_balance: {
    title: "รายการเงินสดคงเหลือในมือและอื่นๆ",
    creatable: true,
    selected: true,
  },
  outstanding_debt: {
    title: "หนี้คงค้าง ณ สิ้นสุด ประจำเดือน",
    creatable: true,
    selected: true,
  },
};
export default class CashFlowReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_print: false,
      modal_expenses: false,
      // TAB1
      prev_balance_bank: { show: false, data: [] },
      prev_balance_cash: { show: false, data: [] },
      // TAB2
      income_received: { show: false, data: [] },
      other_income: { show: false, data: [] },
      deduction_amount: { show: false, data: [] },
      expense_amount: { show: false, data: [] },
      bank_deposit_balance: { show: false, data: [] },
      cash_deposit_balance: { show: false, data: [] },
      outstanding_debt: { show: false, data: [] },

      data_setting: null,

      filter_search: "",

      tab: "ยอดที่ยกมา",
      tab_menu: "สร้าง",

      report_id: "",
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      status: "pending",

      image: "",
      image_index: -1,
      data_index: "",

      dropdown: false,

      data: [],
      data_expense_type: [],

      type: "",

      expenses_type_center: "",
      index_expenses: -1,
      index_type: "",
      index_sub: -1,

      last_bookbank_balance: 0,
    };
    this.inputRefs = [];
  }

  async componentDidMount() {
    await this.Get();
    await this.GetExpenseCenter();
  }
  Get = async () => {
    const { year, month } = this.state;
    loading(true);
    let data, data_setting, data_monthly, last_bookbank_balance;
    let [result, result_setting] = await Promise.all([
      GET("api/admin/setting-cash-flow-report/list"),
      GET("api/admin/setting-cash-flow-report/setting-list", { year, month }),
    ]);
    if (result.status) {
      data = result.data;
    }
    if (result_setting.status) {
      data_setting = result_setting.data;
      last_bookbank_balance = result_setting.data.last_bookbank_balance;
    }
    const _data = data?.filter((e) => e.status !== "cancel");
    if (_data && _data[0] && _data[0]?.status === "pending") {
      // เคส ยังไม่ได้ อนุมัติ
      this.setState({ data, ..._data[0], data_setting });
    } else if (_data && _data[0] && _data[0]?.status === "approved") {
      // เคส อนุมัติเดือนก่อนไปแล้ว แต่ยังไม่ได้ทำของเดือนนี้
      let date = new Date(_data[0].year, _data[0].month + 1);

      let result_monthly = await GET("api/admin/cash-flow-report/monthly-new", {
        month: format_date(date, "yyyy-mm", "en"),
      });

      if (result_monthly.status) {
        data_monthly = result_monthly.data;
      }

      // ดึงรายการรับเงิน จากระบบมาใส่ตัวแปร
      let income_received = data_setting.income_received;
      for (let item of income_received.data) {
        if (JSON.stringify(item.title).includes("ประปา")) {
          item.amount = data_monthly.income_received[0]?.water_bill || 0;
        }
        if (JSON.stringify(item.title).includes("อุปกรณ์")) {
          item.amount =
            data_monthly.income_received[0]?.equipment_maintenance_fee || 0;
        }
        if (JSON.stringify(item.title).includes("ขยะ")) {
          item.amount = data_monthly.income_received[0]?.waste_cost || 0;
        }
        if (JSON.stringify(item.title).includes("กลาง")) {
          item.amount = data_monthly.income_received[0]?.common_expenses || 0;
        }
      }

      // ดึงรายการ รายรับอื่นๆ จากระบบมาใส่ตัวแปร
      let other_income = data_setting.other_income;
      for (let item of other_income.data) {
        item.amount =
          data_monthly.other_income.find((e) => e.title === item.title[0].value)
            ?.total_cost || 0;
      }

      let prev_balance_bank = _data[0]?.bank_deposit_balance;
      let prev_balance_cash = _data[0]?.cash_deposit_balance;

      this.setState({
        data,
        ...data_setting,
        income_received,
        other_income,
        prev_balance_bank,
        prev_balance_cash,
        year: date.getFullYear(),
        month: date.getMonth(),
        data_setting,
        last_bookbank_balance,
      });
    } else {
      // เคส ยังไม่มีข้อมูลเดือนก่อนเลย
      let result_monthly = await GET("api/admin/cash-flow-report/monthly-new", {
        month: format_date(new Date(year, month - 1), "yyyy-mm", "en"),
      });

      if (result_monthly.status) {
        data_monthly = result_monthly.data;
      }

      // ดึงรายการรับเงิน จากระบบมาใส่ตัวแปร
      let income_received = data_setting?.income_received;
      if (income_received) {
        for (let item of income_received?.data) {
          if (JSON.stringify(item.title).includes("ประปา")) {
            item.amount =
              data_monthly.income_received[0]?.water_bill?.toFixed(2) || 0;
          }
          if (JSON.stringify(item.title).includes("อุปกรณ์")) {
            item.amount =
              data_monthly.income_received[0]?.equipment_maintenance_fee?.toFixed(
                2,
              ) || 0;
          }
          if (JSON.stringify(item.title).includes("ขยะ")) {
            item.amount =
              data_monthly.income_received[0]?.waste_cost?.toFixed(2) || 0;
          }
          if (JSON.stringify(item.title).includes("กลาง")) {
            item.amount =
              data_monthly.income_received[0]?.common_expenses?.toFixed(2) || 0;
          }
        }
      }

      // ดึงรายการ รายรับอื่นๆ จากระบบมาใส่ตัวแปร
      let other_income = data_setting?.other_income;
      if (other_income) {
        for (let item of other_income.data) {
          item.amount =
            data_monthly.other_income?.find(
              (e) => e.title === item.title[0].value,
            )?.total_cost || 0;
        }
      }

      this.setState({
        data,
        ...data_setting,
        income_received,
        other_income,
        data_setting,
        last_bookbank_balance,
      });
    }
    loading(false);
  };
  GetByID = async (report_id) => {
    loading(true);
    let result = await GET("api/admin/setting-cash-flow-report/list", {
      report_id,
    });
    if (result.status) {
      this.setState({ ...result.data });
    }
    loading(false);
  };
  GetExpenseCenter = async () => {
    loading(true);
    let result = await GET("api/admin/expense-types-centers/list", null);
    if (result?.status) {
      this.setState({
        data_expense_type: result.data
          ?.filter((e) => e.is_active)
          .map((e) => ({
            value: e.expense_type_id,
            label: e.expense_type_name,
          })),
      });
    }
    loading(false);
  };
  CreateUpdate = async (status) => {
    if (
      await alert(
        "",
        "info",
        "ยืนยัน",
        "กรุณาอัปโหลดรูปภาพให้ครบทุกครั้ง เพื่อให้ข้อมูลสมบูรณ์และสะดวกต่อการตรวจสอบ",
        "บันทึกต่อ",
        "ย้อนกลับ",
      )
    ) {
      const {
        report_id,
        year,
        month,
        income_received,
        other_income,
        deduction_amount,
        expense_amount,
        bank_deposit_balance,
        cash_deposit_balance,
        outstanding_debt,
        prev_balance_bank,
        prev_balance_cash,
      } = this.state;
      loading(true);

      const uploadItem = async (item) => {
        if (item.image && item.image.includes("base64")) {
          const res = await POST("api/admin/upload-data/image", {
            image_slip: [item.image],
          });
          item.image = res.data[0];
        }

        if (item.excel && item.excel.includes("base64")) {
          const res = await POST("api/admin/upload-data/file", {
            file: item.excel,
          });
          item.excel = res.data;
        }

        if (item.pdf && item.pdf.includes("base64")) {
          const res = await POST("api/admin/upload-data/file", {
            file: item.pdf,
          });
          item.pdf = res.data;
        }
      };

      const processData = async (obj) => {
        await Promise.all(obj.data.map(uploadItem));
      };

      // 🔥 รวมทุก array ไว้ทีเดียว
      const allData = [
        income_received,
        other_income,
        deduction_amount,
        expense_amount,
        bank_deposit_balance,
        cash_deposit_balance,
        outstanding_debt,
        prev_balance_bank,
        prev_balance_cash,
      ];

      // clone ถ้าจำเป็น
      const clonedData = allData
        .filter((e) => e)
        .map((d) => ({ ...d, data: [...d.data] }));

      // run
      await Promise.all(clonedData.map(processData));

      let body = {
        year,
        month,
        status,
        income_received,
        other_income,
        deduction_amount,
        expense_amount,
        bank_deposit_balance,
        cash_deposit_balance,
        outstanding_debt,
        prev_balance_bank,
        prev_balance_cash,
      };
      let result = !report_id
        ? await POST("api/admin/cash-flow-report/create", body)
        : await PUT("api/admin/cash-flow-report/update/" + report_id, body);
      if (result?.status) {
        alert("#", "success");
      }
      loading(false);
    }
  };
  componentTable = (data, data_index) => {
    const {
      type,
      image_index,
      year,
      month,
      data_expense_type,
      data_setting,
      last_bookbank_balance,
    } = this.state;
    return (
      <div
        className="card rounded-4 border-0 overflow-hidden mb-3"
        key={data_index}
      >
        <div className="table-responsive">
          <table className="table table-hover mb-0">
            <thead>
              <tr
                className={`${
                  ["deduction_amount", "expense_amount"].includes(data)
                    ? "bg-danger"
                    : "bg-success"
                } text-white pointer`}
                onClick={async () => {
                  this.setState((prevState) => ({
                    [data]: {
                      ...prevState[data],
                      show: !prevState[data]?.show,
                    },
                  }));
                }}
              >
                <th
                  className={
                    ["deduction_amount", "expense_amount"].includes(data)
                      ? "bg-danger"
                      : "bg-success"
                  }
                  colSpan={3}
                >
                  <div className="d-flex">
                    {type === "print" && (
                      <div className="d-flex text-center align-item-center justify-content-center p-1 bg-light rounded-3 me-2">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            title_data[data].selected = e.target.checked;
                          }}
                          checked={title_data[data].selected}
                        />
                      </div>
                    )}
                    {title_data[data].title.split("\n").map((e) => (
                      <h6 className="fw-bold mb-1">
                        {["prev_balance_bank", "prev_balance_cash"].includes(
                          data,
                        )
                          ? e +
                            " ณ​ " +
                            format_date(
                              new Date(year, month - 1, 0),
                              "dd mmmm yyyy",
                              "th",
                            )
                          : [
                                "bank_deposit_balance",
                                "cash_deposit_balance",
                              ].includes(data)
                            ? e +
                              " ณ​ " +
                              format_date(
                                new Date(year, month, 0),
                                "dd mmmm yyyy",
                                "th",
                              )
                            : data === "outstanding_debt"
                              ? e +
                                " " +
                                format_date(
                                  new Date(year, month, 0),
                                  "mmmm yyyy",
                                  "th",
                                )
                              : e}
                      </h6>
                    ))}
                  </div>
                </th>
                <th
                  className={`${
                    ["deduction_amount", "expense_amount"].includes(data)
                      ? "bg-danger"
                      : "bg-success"
                  } wpx-250`}
                >
                  <div className="icon text-16 ms-auto wpx-30 text-white">
                    {this.state[data]?.show ? "\uf077" : "\uf078"}
                  </div>
                </th>
              </tr>
            </thead>
            {/* ครอบทั้งหมดด้วย Context */}
            <DragDropContext onDragEnd={this.onDragEnd}>
              {this.state[data]?.show && (
                <Droppable droppableId={data}>
                  {(provided) => (
                    <tbody ref={provided.innerRef} {...provided.droppableProps}>
                      {this.state[data]?.data
                        ?.filter((e) => e.visible)
                        .map((item, index) => (
                          <React.Fragment key={data + "_" + index}>
                          <Draggable
                            key={data + "_drag_" + index}
                            draggableId={data + "_" + index}
                            index={index}
                            isDragDisabled={["view", "print"].includes(type)} // ปิดการลากถ้าเป็นโหมดดูอย่างเดียว
                          >
                            {(provided, snapshot) => (
                              <tr
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                className={(snapshot.isDragging
                                    ? "bg-white shadow-sm"
                                    : "")}
                                style={{
                                  ...provided.draggableProps.style,
                                  display: snapshot.isDragging
                                    ? "table"
                                    : "table-row", // ป้องกันแถวหดตัวขณะลาก
                                    opacity: item?.is_active === false ? 0.1 : 1
                                }}
                              >
                                <td
                                  {...provided.dragHandleProps}
                                  className="wpx-30 text-center align-middle"
                                >
                                  <div className="icon text-secondary text-20">
                                    {"≡"}
                                  </div>
                                </td>
                                <td className="wpx-30 text-center align-middle">
                                  {index + 1}
                                </td>
                                <td className="py-1 align-middle">
                                  <div className="d-flex align-items-center">
                                    {item.title.map((e, idx) => {
                                      if (e.type === "list") {
                                        return ["view", "print"].includes(
                                          type,
                                        ) ? (
                                          <span key={idx}>{e.value}</span>
                                        ) : (
                                          <input
                                            key={idx}
                                            className="form-control mx-1"
                                            type="text"
                                            disabled
                                            readOnly
                                            value={e.value}
                                          />
                                        );
                                      } else if (item.title_editable) {
                                        if (e.type === "text") {
                                          return ["view", "print"].includes(
                                            type,
                                          ) ? (
                                            e.value
                                          ) : (
                                            <input
                                              key={idx}
                                              className="form-control"
                                              type="text"
                                              placeholder="กรุณากรอกข้อความ"
                                              style={{
                                                minWidth: 150,
                                                width:
                                                  e.value.length < 12
                                                    ? 150
                                                    : e.value.length * 7.1,
                                                zIndex: 100,
                                              }}
                                              value={e.value}
                                              onChange={(e) => {
                                                const dataCopy = {
                                                  ...this.state[data],
                                                };
                                                dataCopy.data[index].title[
                                                  idx
                                                ].value = e.target.value;
                                                this.setState({
                                                  [data]: dataCopy,
                                                });
                                              }}
                                            />
                                          );
                                        } else {
                                          return ["view", "print"].includes(
                                            type,
                                          ) ? (
                                            e.value
                                          ) : (
                                            /* ★ ช่องวันที่ใช้ DatePicker เสมอ (dd/mm/yyyy) ไม่ใช้ input type="date" ที่แสดงตาม locale เบราว์เซอร์ */
                                            <div
                                              key={idx}
                                              className="d-inline-block align-middle wpx-110 mx-1"
                                            >
                                              <DatePicker
                                                className="form-control hpx-24 px-1"
                                                value={e.value}
                                                onChange={(value) => {
                                                  const dataCopy = {
                                                    ...this.state[data],
                                                  };
                                                  dataCopy.data[index].title[
                                                    idx
                                                  ].value = value;
                                                  this.setState({
                                                    [data]: dataCopy,
                                                  });
                                                }}
                                              />
                                            </div>
                                          );
                                        }
                                      } else {
                                        if (e.type === "text") {
                                          return (
                                            <span key={idx}>{e.value}</span>
                                          );
                                        } else {
                                          return ["view", "print"].includes(
                                            type,
                                          ) ? (
                                            e.value
                                          ) : (
                                            /* ★ ช่องวันที่ใช้ DatePicker เสมอ (dd/mm/yyyy) ไม่ใช้ input type="date" ที่แสดงตาม locale เบราว์เซอร์ */
                                            <div
                                              key={idx}
                                              className="d-inline-block align-middle wpx-110 mx-1"
                                            >
                                              <DatePicker
                                                className="form-control hpx-24 px-1"
                                                value={e.value}
                                                onChange={(value) => {
                                                  const dataCopy = {
                                                    ...this.state[data],
                                                  };
                                                  dataCopy.data[index].title[
                                                    idx
                                                  ].value = value;
                                                  this.setState({
                                                    [data]: dataCopy,
                                                  });
                                                }}
                                              />
                                            </div>
                                          );
                                        }
                                      }
                                    })}
                                    {!this.isListRow(item) && (
                                      <>
                                        {item.expenses_type_center && (
                                          <small className="text-warning ms-2 text-8">
                                            (
                                            {data_expense_type?.find(
                                              (et) =>
                                                et.value ===
                                                item.expenses_type_center,
                                            )?.label || "-"}
                                            )
                                          </small>
                                        )}
                                        <span
                                          className={
                                            item?.expenses_type_center
                                              ? "icon text-warning mx-2"
                                              : "icon text-secondary mx-2"
                                          }
                                          onClick={() => {
                                            this.setState({
                                              index_type: data,
                                              index_expenses: index,
                                              index_sub: -1,
                                              modal_expenses: true,
                                              expenses_type_center:
                                                this.state[data]?.data[index]
                                                  ?.expenses_type_center || "",
                                            });
                                          }}
                                        >
                                          {"\uf059"}
                                        </span>
                                      </>
                                    )}
                                    {data === "bank_deposit_balance" &&
                                      index === 0 && (
                                        <span className="text-danger">
                                          {last_bookbank_balance
                                            ? toFixed(last_bookbank_balance)
                                            : "0.00"}
                                        </span>
                                      )}
                                  </div>
                                </td>
                                <td className="text-end py-1">
                                  {data_setting?.[data]?.data?.[index]?.visible === false ? null : (
                                    <div className="d-flex align-items-center justify-content-end">
                                      {["view", "print"].includes(type) ||
                                      this.isListRow(item) ? (
                                        toFixed(item.amount)
                                      ) : (
                                        <NumericFormat
                                          thousandSeparator=","
                                          decimalScale={2}
                                          getInputRef={(el) =>
                                            (this.inputRefs[data + index] = el)
                                          }
                                          className={
                                            "form-control w-100 text-end" +
                                            ([
                                              "deduction_amount",
                                              "expense_amount",
                                            ].includes(data)
                                              ? " text-danger"
                                              : "")
                                          }
                                          type="text"
                                          placeholder="กรุณากรอกข้อความ"
                                          value={item.amount}
                                          onValueChange={(e) => {
                                            const dataCopy = {
                                              ...this.state[data],
                                            };
                                            dataCopy.data[index].amount =
                                              e.value;
                                            this.setState({ [data]: dataCopy });
                                          }}
                                          id="fix-enter"
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") {
                                              e.preventDefault();

                                              const nextKey =
                                                data + (index + 1);
                                              const nextInput =
                                                this.inputRefs?.[nextKey];

                                              if (nextInput) {
                                                nextInput.focus();
                                              } else {
                                                if (data !== "expense_amount") {
                                                  const dataCopy = {
                                                    ...this.state[data],
                                                  };

                                                  dataCopy.data.push({
                                                    visible: true,
                                                    title_editable: true,
                                                    title: [
                                                      {
                                                        value: "",
                                                        type: "text",
                                                        required: false,
                                                      },
                                                    ],
                                                    amount_editable: true,
                                                    amount: 0.0,
                                                    expenses_type_center: "",
                                                  });

                                                  this.setState(
                                                    { [data]: dataCopy },
                                                    () => {
                                                      // ⏱ รอ render ก่อน
                                                      setTimeout(() => {
                                                        this.inputRefs?.[
                                                          nextKey
                                                        ]?.focus();
                                                      }, 0);
                                                    },
                                                  );
                                                }
                                              }
                                            }
                                          }}
                                        />
                                      )}
                                      {item.image ? (
                                        <img
                                          className="wpx-25 hpx-25 rounded-3 img-fluid ms-2 pointer"
                                          src={item.image}
                                          alt="slip"
                                          onClick={async () => {
                                            this.setState({
                                              modal_detail: true,
                                              image: item.image,
                                              excel: "",
                                              pdf: "",
                                              image_index: index,
                                              data_index: data,
                                            });
                                          }}
                                        />
                                      ) : (
                                        <div
                                          className="icon text-14 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-primary-light text-primary ms-2"
                                          onClick={async () => {
                                            if (
                                              !["view", "print"].includes(type)
                                            ) {
                                              document
                                                .getElementById("image_" + data)
                                                .click();
                                              this.setState({
                                                image: "",
                                                image_index: index,
                                                data_index: data,
                                              });
                                            }
                                          }}
                                        >
                                          {"\uf03e"}
                                        </div>
                                      )}
                                      {item.excel ? (
                                        <Dropdown className="p-0 ms-2">
                                          <Dropdown.Toggle
                                            variant="white"
                                            id="dropdown-basic"
                                            size="sm"
                                            className="p-0"
                                          >
                                            <div className="icon text-14 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-success text-white">
                                              {"\uf0ce"}
                                            </div>
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                                            <Dropdown.Item
                                              className="rounded-3 d-flex align-items-center px-2"
                                              onClick={async () => {
                                                if (
                                                  !["view", "print"].includes(
                                                    type,
                                                  )
                                                ) {
                                                  document
                                                    .getElementById(
                                                      "excel_" + data,
                                                    )
                                                    .click();
                                                  this.setState({
                                                    image: "",
                                                    image_index: index,
                                                    data_index: data,
                                                  });
                                                }
                                              }}
                                            >
                                              <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                {"\uf093"}
                                              </div>{" "}
                                              อัพโหลดใหม่
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              className="rounded-3 d-flex align-items-center px-2"
                                              onClick={() => {
                                                window.open(
                                                  item.excel,
                                                  "_blank",
                                                );
                                              }}
                                            >
                                              <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                {"\uf019"}
                                              </div>{" "}
                                              ดาวน์โหลด
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              className="rounded-3 d-flex align-items-center px-2 text-danger"
                                              onClick={async () => {
                                                if (
                                                  await alert(
                                                    "",
                                                    "info",
                                                    "ยืนยัน",
                                                    "ยืนยันการลบข้อมูลนี้หรือไม่?",
                                                    "ลบข้อมูล",
                                                    "ยกเลิก",
                                                  )
                                                ) {
                                                  let _data = this.state[data];
                                                  _data.data[index].excel = "";
                                                  this.setState({
                                                    [data]: _data,
                                                  });
                                                }
                                              }}
                                            >
                                              <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                {"\uf2ed"}
                                              </div>{" "}
                                              ลบ
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      ) : (
                                        <div
                                          className="icon text-14 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-primary-light text-primary ms-2"
                                          onClick={async () => {
                                            if (
                                              !["view", "print"].includes(type)
                                            ) {
                                              document
                                                .getElementById("excel_" + data)
                                                .click();
                                              this.setState({
                                                image: "",
                                                image_index: index,
                                                data_index: data,
                                              });
                                            }
                                          }}
                                        >
                                          {"\uf0ce"}
                                        </div>
                                      )}
                                      {item.pdf ? (
                                        <Dropdown className="p-0 ms-2">
                                          <Dropdown.Toggle
                                            variant="white"
                                            id="dropdown-basic"
                                            size="sm"
                                            className="p-0"
                                          >
                                            <div className="icon text-14 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-success text-white">
                                              {"\uf1c1"}
                                            </div>
                                          </Dropdown.Toggle>
                                          <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                                            <Dropdown.Item
                                              className="rounded-3 d-flex align-items-center px-2"
                                              onClick={async () => {
                                                if (
                                                  !["view", "print"].includes(
                                                    type,
                                                  )
                                                ) {
                                                  document
                                                    .getElementById(
                                                      "pdf_" + data,
                                                    )
                                                    .click();
                                                  this.setState({
                                                    image: "",
                                                    image_index: index,
                                                    data_index: data,
                                                  });
                                                }
                                              }}
                                            >
                                              <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                {"\uf093"}
                                              </div>{" "}
                                              อัพโหลดใหม่
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              className="rounded-3 d-flex align-items-center px-2"
                                              onClick={() => {
                                                window.open(item.pdf, "_blank");
                                              }}
                                            >
                                              <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                {"\uf019"}
                                              </div>{" "}
                                              ดาวน์โหลด
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                              className="rounded-3 d-flex align-items-center px-2 text-danger"
                                              onClick={async () => {
                                                if (
                                                  await alert(
                                                    "",
                                                    "info",
                                                    "ยืนยัน",
                                                    "ยืนยันการลบข้อมูลนี้หรือไม่?",
                                                    "ลบข้อมูล",
                                                    "ยกเลิก",
                                                  )
                                                ) {
                                                  let _data = this.state[data];
                                                  _data.data[index].pdf = "";
                                                  this.setState({
                                                    [data]: _data,
                                                  });
                                                }
                                              }}
                                            >
                                              <div className="fw-bold icon me-1 wpx-15 text-center text-12">
                                                {"\uf2ed"}
                                              </div>{" "}
                                              ลบ
                                            </Dropdown.Item>
                                          </Dropdown.Menu>
                                        </Dropdown>
                                      ) : (
                                        <div
                                          className="icon text-14 d-flex align-items-center justify-content-center wpx-25 hpx-25 pointer rounded-3 bg-primary-light text-primary ms-2"
                                          onClick={async () => {
                                            if (
                                              !["view", "print"].includes(type)
                                            ) {
                                              document
                                                .getElementById("pdf_" + data)
                                                .click();
                                              this.setState({
                                                image: "",
                                                image_index: index,
                                                data_index: data,
                                              });
                                            }
                                          }}
                                        >
                                          {"\uf1c1"}
                                        </div>
                                      )}
                                      {item.title_editable &&
                                        !["view", "print"].includes(type) && (
                                          <span
                                            className="wpx-25 hpx-25 d-flex align-items-center justify-content-center bg-danger-light text-danger icon pointer rounded ms-2 mt-1"
                                            onClick={() => {
                                              const dataCopy = {
                                                ...this.state[data],
                                              };
                                              dataCopy.data.splice(index, 1);
                                              this.setState({
                                                [data]: dataCopy,
                                              });
                                            }}
                                          >
                                            {"\uf2ed"}
                                          </span>
                                        )}
                                      {type === "print" && (<Switch
                      className="ms-2"
                        height={20}
                        width={36}
                        onChange={(e) => {
                           const dataCopy = {
                                                  ...this.state[data],
                                                };
                                                dataCopy.data[index].is_active = e;
                                                this.setState({
                                                  [data]: dataCopy,
                                                });
                        }}
                        checked={item.is_active !== false}
                      />)}
                                    </div>
                                  )}
                                </td>
                              </tr>
                            )}
                          </Draggable>
                          {this.isListRow(item) &&
                            (() => {
                              const listIdx = this.getListTitleIndex(item);
                              const list = item.title[listIdx].list;
                              return (
                                <>
                                  {list.map((sub, subIdx) => (
                                    <tr
                                      key={`${data}_${index}_sub_${subIdx}`}
                                      className="bg-light"
                                    >
                                      <td className="wpx-30"></td>
                                      <td className="wpx-30 text-center align-middle text-10">
                                        {`${index + 1}.${subIdx + 1}`}
                                      </td>
                                      <td className="py-1 align-middle">
                                        <div className="d-flex align-items-center">
                                          {["view", "print"].includes(
                                            type,
                                          ) ? (
                                            sub.value
                                          ) : (
                                            <input
                                              className="form-control"
                                              type="text"
                                              placeholder="กรุณากรอกข้อความ"
                                              value={sub.value}
                                              onChange={(e) => {
                                                const dataCopy = {
                                                  ...this.state[data],
                                                };
                                                dataCopy.data[index].title[
                                                  listIdx
                                                ].list[subIdx].value =
                                                  e.target.value;
                                                this.recomputeListRow(
                                                  dataCopy,
                                                  index,
                                                  listIdx,
                                                );
                                                this.setState({
                                                  [data]: dataCopy,
                                                });
                                              }}
                                            />
                                          )}
                                          {sub.expenses_type_center && (
                                            <small className="text-warning ms-2 text-8">
                                              (
                                              {data_expense_type?.find(
                                                (et) =>
                                                  et.value ===
                                                  sub.expenses_type_center,
                                              )?.label || "-"}
                                              )
                                            </small>
                                          )}
                                          <span
                                            className={
                                              sub.expenses_type_center
                                                ? "icon text-warning mx-2"
                                                : "icon text-secondary mx-2"
                                            }
                                            onClick={() => {
                                              this.setState({
                                                index_type: data,
                                                index_expenses: index,
                                                index_sub: subIdx,
                                                modal_expenses: true,
                                                expenses_type_center:
                                                  sub.expenses_type_center ||
                                                  "",
                                              });
                                            }}
                                          >
                                            {""}
                                          </span>
                                        </div>
                                      </td>
                                      <td className="text-end py-1">
                                        <div className="d-flex align-items-center justify-content-end">
                                          {["view", "print"].includes(
                                            type,
                                          ) ? (
                                            toFixed(sub.amount)
                                          ) : (
                                            <NumericFormat
                                              thousandSeparator=","
                                              decimalScale={2}
                                              className="form-control w-100 text-end text-danger"
                                              type="text"
                                              placeholder="กรุณากรอกข้อความ"
                                              value={sub.amount}
                                              onValueChange={(e) => {
                                                const dataCopy = {
                                                  ...this.state[data],
                                                };
                                                dataCopy.data[index].title[
                                                  listIdx
                                                ].list[subIdx].amount =
                                                  e.value;
                                                this.recomputeListRow(
                                                  dataCopy,
                                                  index,
                                                  listIdx,
                                                );
                                                this.setState({
                                                  [data]: dataCopy,
                                                });
                                              }}
                                            />
                                          )}
                                          {list.length > 1 &&
                                            !["view", "print"].includes(
                                              type,
                                            ) && (
                                              <span
                                                className="wpx-25 hpx-25 d-flex align-items-center justify-content-center bg-danger-light text-danger icon pointer rounded ms-2"
                                                onClick={() =>
                                                  this.removeListSubItem(
                                                    data,
                                                    index,
                                                    subIdx,
                                                  )
                                                }
                                              >
                                                {""}
                                              </span>
                                            )}
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                  {!["view", "print"].includes(type) && (
                                    <tr
                                      key={`${data}_${index}_addsub`}
                                      className="bg-light pointer"
                                      onClick={() =>
                                        this.addListSubItem(data, index)
                                      }
                                    >
                                      <td
                                        colSpan={4}
                                        className="ps-4 py-1 text-primary"
                                      >
                                        <span className="icon me-2">
                                          {""}
                                        </span>
                                        เพิ่มรายการย่อย
                                      </td>
                                    </tr>
                                  )}
                                </>
                              );
                            })()}
                          </React.Fragment>
                        ))}

                      {/* ส่วนของ provided.placeholder ต้องอยู่ข้างใน tbody แต่อยู่หลังรายการที่ map */}
                      {provided.placeholder}

                      {title_data[data].creatable &&
                        !["view", "print"].includes(type) && (
                          <tr
                            className="bg-primary-light pointer"
                            onClick={() => {
                              if (data !== "expense_amount") {
                                const dataCopy = { ...this.state[data] };
                                dataCopy.data.push({
                                  visible: true,
                                  title_editable: true,
                                  title: [
                                    {
                                      value: "",
                                      type: "text",
                                      required: false,
                                    },
                                  ],
                                  amount_editable: true,
                                  amount: 0.0,
                                  expenses_type_center: "",
                                });
                                this.setState({ [data]: dataCopy });
                              }
                            }}
                          >
                            <td colSpan={4} className="bg-success-light py-0">
                              {data !== "expense_amount" ? (
                                <div className="position-relative w-100 py-2">
                                  <span className="icon text-primary me-2">
                                    {"\uf055"}
                                  </span>
                                  เพิ่มรายการ
                                </div>
                              ) : (
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant="gray"
                                    id="dropdown-basic"
                                    size="sm"
                                    className="w-100 text-start py-2"
                                  >
                                    <div className="position-relative w-100">
                                      <span className="icon text-primary me-2">
                                        {"\uf055"}
                                      </span>
                                      เพิ่มรายการ
                                    </div>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="shadow overflow-hidden border-0 rounded-4 p-2">
                                    <Dropdown.Item
                                      className="rounded-3 d-flex align-items-center px-2"
                                      onClick={() => {
                                        const dataCopy = {
                                          ...this.state[data],
                                        };
                                        dataCopy.data.push({
                                          visible: true,
                                          title_editable: true,
                                          title: [
                                            {
                                              value: "",
                                              type: "text",
                                              required: false,
                                            },
                                            {
                                              value: "",
                                              type: "date",
                                              required: true,
                                            },
                                            {
                                              value: "",
                                              type: "text",
                                              required: false,
                                            },
                                          ],
                                          amount_editable: true,
                                          amount: 0.0,
                                          expenses_type_center: "",
                                        });
                                        this.setState({ [data]: dataCopy });
                                      }}
                                    >
                                      เช็ค
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      className="rounded-3 d-flex align-items-center px-2"
                                      onClick={() => {
                                        const dataCopy = {
                                          ...this.state[data],
                                        };
                                        dataCopy.data.push({
                                          visible: true,
                                          title_editable: true,
                                          title: [
                                            {
                                              value: "",
                                              type: "text",
                                              required: false,
                                            },
                                            {
                                              value: "",
                                              type: "date",
                                              required: true,
                                            },
                                            {
                                              value: "",
                                              type: "list",
                                              required: false,
                                              list: [
                                                {
                                                  value: "",
                                                  amount: 0.0,
                                                  expenses_type_center: "",
                                                  type: "text",
                                                  required: false,
                                                },
                                              ],
                                            },
                                          ],
                                          amount_editable: true,
                                          amount: 0.0,
                                          expenses_type_center: "",
                                        });
                                        this.setState({ [data]: dataCopy });
                                      }}
                                    >
                                      เช็ค (List)
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      className="rounded-3 d-flex align-items-center px-2"
                                      onClick={() => {
                                        const dataCopy = {
                                          ...this.state[data],
                                        };
                                        dataCopy.data.push({
                                          visible: true,
                                          title_editable: true,
                                          title: [
                                            {
                                              value: "",
                                              type: "text",
                                              required: false,
                                            },
                                          ],
                                          amount_editable: true,
                                          amount: 0.0,
                                        });
                                        this.setState({ [data]: dataCopy });
                                      }}
                                    >
                                      ข้อความ
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              )}
                            </td>
                          </tr>
                        )}
                      <tr>
                        <td colSpan={3}>
                          {data === "expense_amount"
                            ? "รวมรายการจ่ายเงินประจำเดือน " +
                              format_date(
                                new Date(year, month - 1),
                                "mmmm yyyy",
                                "th",
                              )
                            : "รวมทั้งสิ้น"}
                        </td>
                        <td className="text-end">
                          {toFixed(total(this.state[data]?.data, "amount"))}
                        </td>
                      </tr>
                    </tbody>
                  )}
                </Droppable>
              )}
            </DragDropContext>
          </table>
        </div>
        <input
          hidden
          accept="image/*"
          id={"image_" + data}
          type="file"
          onChange={async (e) => {
            let image = await new Promise((resolve) => {
              Resizer.imageFileResizer(
                e.target.files[0],
                1200,
                1200,
                "JPEG",
                100,
                0,
                (uri) => {
                  resolve(uri);
                },
                "base64",
              );
            });
            let _data = this.state[data];
            _data.data[image_index] = {
              ..._data.data[image_index],
              image: image,
            };
            this.setState({ [data]: _data });
            e.target.value = "";
            e.target.files = null;
          }}
        />
        <input
          hidden
          accept=".xlsx,.xls"
          id={"excel_" + data}
          type="file"
          onChange={async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const base64 = await new Promise((resolve, reject) => {
              const reader = new FileReader();

              reader.readAsDataURL(file); // 👈 แปลงเป็น base64

              reader.onload = () => resolve(reader.result);
              reader.onerror = (error) => reject(error);
            });

            // ✅ clone state ป้องกัน mutation
            let _data = { ...this.state[data] };
            _data.data = [..._data.data];

            _data.data[image_index] = {
              ..._data.data[image_index],
              excel: base64,
            };

            this.setState({ [data]: _data });

            // reset input
            e.target.value = "";
          }}
        />
        <input
          hidden
          accept="application/pdf"
          id={"pdf_" + data}
          type="file"
          onChange={async (e) => {
            const file = e.target.files[0];
            if (!file) return;

            const base64 = await new Promise((resolve, reject) => {
              const reader = new FileReader();

              reader.readAsDataURL(file); // ✅ ใช้เหมือนเดิม

              reader.onload = () => resolve(reader.result);
              reader.onerror = (error) => reject(error);
            });

            // ✅ clone state
            let _data = { ...this.state[data] };
            _data.data = [..._data.data];

            _data.data[image_index] = {
              ..._data.data[image_index],
              pdf: base64,
            };

            this.setState({ [data]: _data });

            // reset input
            e.target.value = "";
          }}
        />
      </div>
    );
  };
  Delete = async (report_id) => {
    Swal.fire({
      title: "ยืนยัน",
      text: `ยืนยันการลบข้อมูลนี้หรือไม่?`,
      icon: "info",
      input: "textarea",
      inputPlaceholder: "กรอกเหตุผล...",
      showCancelButton: true,
      confirmButtonText: "ลบข้อมูล",
      cancelButtonText: "ยกเลิก",
      confirmButtonColor: "#198754",
      cancelButtonColor: "unset",
    }).then(async (re) => {
      if (re.isConfirmed) {
        const remark = re.value;
        loading(true);
        let body = { status: "cancel", remark };
        let result = await PUT(
          "api/admin/cash-flow-report/update/" + report_id,
          body,
        );
        if (result?.status) {
          alert("#", "success");
        }
        loading(false);
      }
    });
  };
  exportExcel = async () => {
    const {
      prev_balance_bank,
      prev_balance_cash,
      income_received,
      other_income,
      deduction_amount,
      expense_amount,
      bank_deposit_balance,
      cash_deposit_balance,
      outstanding_debt,
      year,
      month,
    } = this.state;

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("Summary");

    // ===== COLUMN =====
    ws.columns = [{ width: 10 }, { width: 50 }, { width: 20 }];

    let rowIndex = 1;

    // ===== SECTION HEADER =====
    const sectionHeader = (
      text,
      color = "198754",
      font_color = "FFFFFF",
      alignment = "left",
    ) => {
      ws.mergeCells(rowIndex, 1, rowIndex, 4);
      const row = ws.getRow(rowIndex);
      row.getCell(1).value = text;
      row.getCell(1).font = { bold: true, color: { argb: font_color } };
      if (color) {
        row.getCell(1).fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: color.startsWith("FF") ? color : `FF${color}` },
        };
      }
      row.alignment = { horizontal: alignment, vertical: "middle" };
      row.height = 25;
      rowIndex++;
    };

    // ===== TABLE ROW =====
    const tableRow = (no, name, amount) => {
      const row = ws.getRow(rowIndex);
      row.values = [no, name, Number(amount)];
      row.getCell(3).numFmt = "#,##0.00";
      row.getCell(3).alignment = { horizontal: "right", vertical: "middle" };
      rowIndex++;
    };

    const tableRowUnderLine = (no, name, amount) => {
      const row = ws.getRow(rowIndex);

      row.getCell(1).value = no;
      row.getCell(2).value = name;

      const cell3 = row.getCell(3);
      cell3.value = Number(amount || 0); // 👈 กัน null/undefined
      cell3.alignment = { horizontal: "right", vertical: "middle" };
      cell3.numFmt = "#,##0.00";

      // 👇 ใส่ border (เผื่ออนาคตมีด้านอื่นจะไม่ overwrite)
      cell3.border = {
        ...cell3.border,
        bottom: { style: "thin" },
      };

      rowIndex++;
    };

    // ===== TABLE ROW (เช็ค List: รายการย่อย) =====
    const tableRowSub = (label, name, amount) => {
      const row = ws.getRow(rowIndex);
      row.values = [label, "     " + name, Number(amount || 0)];
      row.font = { italic: true, color: { argb: "FF6c757d" } };
      row.getCell(3).numFmt = "#,##0.00";
      row.getCell(3).alignment = { horizontal: "right", vertical: "middle" };
      rowIndex++;
    };

    // ===== TOTAL ROW =====
    const totalRow = (label, value) => {
      ws.mergeCells(rowIndex, 1, rowIndex, 3);
      const row = ws.getRow(rowIndex);
      row.getCell(1).value = label;
      row.getCell(1).alignment = { horizontal: "right", vertical: "middle" };
      row.getCell(4).value = Number(value);
      row.getCell(4).alignment = { horizontal: "right", vertical: "middle" };
      row.getCell(4).numFmt = "#,##0.00";
      row.font = { bold: true };
      rowIndex++;
    };

    const totalRowAllUnderLine = (label, value) => {
      ws.mergeCells(rowIndex, 1, rowIndex, 3);
      const row = ws.getRow(rowIndex);

      const cell1 = row.getCell(1);
      cell1.value = label;
      cell1.alignment = { horizontal: "right", vertical: "middle" };
      cell1.numFmt = "#,##0.00";
      cell1.border = { top: { style: "thin" }, bottom: { style: "double" } };

      const cell4 = row.getCell(4);
      cell4.value = Number(value);
      cell4.alignment = { horizontal: "right", vertical: "middle" };
      cell4.numFmt = "#,##0.00";
      cell4.border = { top: { style: "thin" }, bottom: { style: "double" } };

      row.font = { bold: true };
      rowIndex++;
    };

    // ===== FINAL ROW =====
    const finalRow = (label, value) => {
      ws.mergeCells(rowIndex, 1, rowIndex, 3);
      const row = ws.getRow(rowIndex);
      row.getCell(1).value = label;
      row.getCell(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E7F1FF" },
      };
      row.getCell(1).alignment = { horizontal: "right", vertical: "middle" };
      row.getCell(2).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E7F1FF" },
      };
      row.getCell(3).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E7F1FF" },
      };
      row.getCell(4).value = Number(value);
      row.getCell(4).numFmt = "#,##0.00";
      row.getCell(4).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E7F1FF" },
      };
      row.getCell(4).alignment = { horizontal: "right", vertical: "middle" };
      row.font = { bold: true };
      row.height = 30;

      rowIndex++;
    };
    const finalRowBottomUnderLine = (label, value) => {
      ws.mergeCells(rowIndex, 1, rowIndex, 3);

      const row = ws.getRow(rowIndex);

      // 👇 ใส่ style ให้ทุก cell
      [1, 2, 3, 4].forEach((col) => {
        const cell = row.getCell(col);

        // background
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "E7F1FF" },
        };

        // 👇 เส้นล่างทุก cell
        cell.border = {
          ...cell.border,
          bottom: { style: "double" },
        };
      });

      // label
      row.getCell(1).value = label;
      row.getCell(1).alignment = { horizontal: "right", vertical: "middle" };

      // value
      const cell4 = row.getCell(4);
      cell4.value = Number(value);
      cell4.alignment = { horizontal: "right", vertical: "middle" };
      cell4.numFmt = "#,##0.00";

      row.font = { bold: true };
      row.height = 30;

      rowIndex++;
    };
    const finalRowUnderLine = (label, value, top, bottom) => {
      ws.mergeCells(rowIndex, 1, rowIndex, 3);
      const row = ws.getRow(rowIndex);
      row.getCell(1).value = label;
      row.getCell(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E7F1FF" },
      };
      row.getCell(1).alignment = { horizontal: "right", vertical: "middle" };
      row.getCell(2).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E7F1FF" },
      };
      row.getCell(3).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E7F1FF" },
      };

      const cell4 = row.getCell(4);
      cell4.value = Number(value);
      cell4.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "E7F1FF" },
      };
      cell4.alignment = { horizontal: "right", vertical: "middle" };
      cell4.numFmt = "#,##0.00";
      cell4.border = { bottom: { style: "double" } };

      row.font = { bold: true };
      row.height = 30;

      rowIndex++;
    };
    const finalRowAllUnderLine = (label, value) => {
      ws.mergeCells(rowIndex, 1, rowIndex, 3);

      const row = ws.getRow(rowIndex);

      // 👇 loop ใส่ style ให้ทั้งแถว
      [1, 2, 3, 4].forEach((col) => {
        const cell = row.getCell(col);

        // background
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "E7F1FF" },
        };

        // border ทั้งแถว
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "double" },
        };
      });

      // label
      row.getCell(1).value = label;
      row.getCell(1).alignment = { horizontal: "right", vertical: "middle" };

      // value
      const cell4 = row.getCell(4);
      cell4.value = Number(value);
      cell4.alignment = { horizontal: "right", vertical: "middle" };
      cell4.numFmt = "#,##0.00";

      row.font = { bold: true };
      row.height = 30;

      rowIndex++;
    };

    sectionHeader(
      `${project?.project_name || "ผู้ดูแลระบบ"}`,
      null,
      "000000",
      "center",
    );
    sectionHeader(
      `รายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย`,
      null,
      "000000",
      "center",
    );
    sectionHeader(
      `สิ้นสุดวันที่ ${format_date(new Date(year, month, 0), "dd mmmm yyyy", "th")}`,
      null,
      "000000",
      "center",
    );
    // ===== SECTION 1 =====
    sectionHeader(
      "สรุปยอดบัญชีเงินฝากธนาคารและเงินสดคงเหลือในมือยกมา ณ​ " +
        format_date(new Date(year, month - 1, 0), "dd mmmm yyyy", "th"),
    );
    prev_balance_bank?.data?.filter(e=> e.is_active !== false).forEach((item, i) => {
      tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
    });

    totalRow("รวมทั้งสิ้น", total(prev_balance_bank?.data, "amount"));
    rowIndex++;

    // ===== SECTION 2 =====
    sectionHeader(
      "รายการเงินสดคงเหลือในมือและอื่นๆ ณ​ " +
        format_date(new Date(year, month - 1, 0), "dd mmmm yyyy", "th"),
    );
    prev_balance_cash.data.filter(e=> e.is_active !== false)
      .filter((e, i) => i !== prev_balance_cash.data.length - 1)
      .forEach((item, i) => {
        tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
      });
    prev_balance_cash.data.filter(e=> e.is_active !== false)
      .filter((e, i) => i === prev_balance_cash.data.length - 1)
      .forEach((item, i) => {
        tableRowUnderLine(
          i + 1,
          item.title.map((e) => e.value).join(" "),
          item.amount,
        );
      });

    totalRow("รวมทั้งสิ้น", total(prev_balance_cash.data, "amount"));
    rowIndex++;

    // ===== TOTAL =====
    finalRowUnderLine(
      "รวมยอดเงินฝากธนาคาร เงินสดคงเหลือในมือ และอื่นๆ ยกมา",
      total(prev_balance_bank?.data, "amount") +
        total(prev_balance_cash?.data, "amount"),
    );
    rowIndex++;

    // ===== SECTION 3 =====
    sectionHeader("รายการรับเงิน");
    income_received.data.filter(e=> e.is_active !== false)
      .filter((e, i) => i !== income_received.data.length - 1)
      .forEach((item, i) => {
        tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
      });
    income_received.data.filter(e=> e.is_active !== false)
      .filter((e, i) => i === income_received.data.length - 1)
      .forEach((item, i) => {
        tableRowUnderLine(
          i + 1,
          item.title.map((e) => e.value).join(" "),
          item.amount,
        );
      });

    totalRow("รวมทั้งสิ้น", total(income_received.data, "amount"));
    rowIndex++;

    // ===== SECTION 4 =====
    sectionHeader("รายรับอื่นๆ");
    other_income.data.filter(e=> e.is_active !== false)
      .filter((e, i) => i !== other_income.data.length - 1)
      .forEach((item, i) => {
        tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
      });
    other_income.data.filter(e=> e.is_active !== false)
      .filter((e, i) => i === other_income.data.length - 1)
      .forEach((item, i) => {
        tableRowUnderLine(
          i + 1,
          item.title.map((e) => e.value).join(" "),
          item.amount,
        );
      });

    totalRow("รวมทั้งสิ้น", total(other_income.data, "amount"));
    rowIndex++;

    // ===== SECTION 5 =====
    sectionHeader("หัก/เพิ่ม/ลดหนี้", "dc3545");
    deduction_amount.data.filter(e=> e.is_active !== false).forEach((item, i) => {
      tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
    });
    totalRow("รวมทั้งสิ้น", total(deduction_amount.data, "amount"));
    rowIndex++;

    // ===== TOTAL =====
    finalRowAllUnderLine(
      `รวมรับเงินและนำฝากประจำเดือน ${format_date(new Date(year, month - 1), "mmmm yyyy", "th")}`,
      total(income_received?.data, "amount") +
        total(other_income?.data, "amount") +
        total(deduction_amount?.data, "amount"),
    );
    rowIndex++;

    // ===== SECTION 6 =====
    sectionHeader("รายการจ่ายเงิน", "dc3545");
    expense_amount.data.filter(e=> e.is_active !== false).forEach((item, i) => {
      tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
      if (this.isListRow(item)) {
        const listIdx = this.getListTitleIndex(item);
        item.title[listIdx].list.forEach((sub, subIdx) => {
          tableRowSub(`${i + 1}.${subIdx + 1}`, sub.value, sub.amount);
        });
      }
    });
    totalRowAllUnderLine(
      "รวมรายการจ่ายเงินประจำเดือน " +
        format_date(new Date(year, month - 1), "mmmm yyyy", "th"),
      total(expense_amount.data, "amount"),
    );

    // ===== TOTAL =====
    finalRowBottomUnderLine(
      `ประจำเดือน ${format_date(new Date(year, month - 1), "mmmm yyyy", "th")} รายการรับเงิน ${total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") + total(expense_amount?.data, "amount") < 0 ? "น้อยกว่า" : "มากกว่า"} รายการจ่ายเงิน`,
      total(income_received?.data, "amount") +
        total(other_income?.data, "amount") +
        total(deduction_amount?.data, "amount") +
        total(expense_amount?.data, "amount"),
    );
    rowIndex++;

    // ===== TOTAL =====
    finalRowAllUnderLine(
      `รวมรายการรับเงิน ${total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") + total(expense_amount?.data, "amount") + total(prev_balance_bank?.data, "amount") + total(prev_balance_cash?.data, "amount") < 0 ? "น้อยกว่า" : "มากกว่า"} รายการจ่ายเงินสะสม`,
      total(income_received?.data, "amount") +
        total(other_income?.data, "amount") +
        total(deduction_amount?.data, "amount") +
        total(expense_amount?.data, "amount") +
        total(prev_balance_bank?.data, "amount") +
        total(prev_balance_cash?.data, "amount"),
    );
    rowIndex++;

    // ===== SECTION 7 =====
    sectionHeader(
      `ยอดเงินฝากธนาคาร ${project?.project_name || "ผู้ดูแลระบบ"}​ ณ ` +
        format_date(new Date(year, month, 0), "dd mmmm yyyy", "th"),
    );
    bank_deposit_balance.data.filter(e=> e.is_active !== false).forEach((item, i) => {
      tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
    });
    totalRow("รวมทั้งสิ้น", total(bank_deposit_balance.data, "amount"));
    rowIndex++;

    // ===== SECTION 8 =====
    sectionHeader(
      "รายการเงินสดคงเหลือในมือและอื่นๆ ณ​ " +
        format_date(new Date(year, month, 0), "dd mmmm yyyy", "th"),
    );
    cash_deposit_balance.data.filter(e=> e.is_active !== false)
      .filter((e, i) => i !== cash_deposit_balance.data.length - 1)
      .forEach((item, i) => {
        tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
      });
    cash_deposit_balance.data.filter(e=> e.is_active !== false)
      .filter((e, i) => i === cash_deposit_balance.data.length - 1)
      .forEach((item, i) => {
        tableRowUnderLine(
          i + 1,
          item.title.map((e) => e.value).join(" "),
          item.amount,
        );
      });

    totalRow("รวมทั้งสิ้น", total(cash_deposit_balance.data, "amount"));
    rowIndex++;

    // ===== TOTAL =====
    finalRowUnderLine(
      "รวมยอดเงินฝากธนาคาร เงินสดคงเหลือในมือและอื่นๆ ยกไป",
      total(bank_deposit_balance?.data, "amount") +
        total(cash_deposit_balance?.data, "amount"),
    );
    rowIndex++;

    // ===== TOTAL =====
    // finalRow(`ประจำเดือน ${format_date( new Date(year, month - 1), "mmmm yyyy", "th" )} รายการรับเงิน มากกว่า รายการจ่ายเงิน`, ( total(income_received?.data, "amount") + total(other_income?.data, "amount") + total(deduction_amount?.data, "amount") + total(expense_amount?.data, "amount") + total(bank_deposit_balance?.data, "amount") + total(cash_deposit_balance?.data, "amount") + total(prev_balance_bank?.data, "amount") + total(prev_balance_cash?.data, "amount") ));
    // rowIndex++;

    // ===== TOTAL =====
    finalRow(
      "ส่วนต่างยอดปิดบัญชี",
      total(income_received?.data, "amount") +
        total(other_income?.data, "amount") +
        total(deduction_amount?.data, "amount") +
        total(expense_amount?.data, "amount") +
        total(prev_balance_bank?.data, "amount") +
        total(prev_balance_cash?.data, "amount") -
        (total(bank_deposit_balance?.data, "amount") +
          total(cash_deposit_balance?.data, "amount")),
    );
    rowIndex++;

    sectionHeader(
      "หนี้คงค้าง ณ สิ้นสุด ประจำเดือน​ " +
        format_date(new Date(year, month, 0), "mmmm yyyy", "th"),
    );
    outstanding_debt?.data?.filter(e=> e.is_active !== false).forEach((item, i) => {
      tableRow(i + 1, item.title.map((e) => e.value).join(" "), item.amount);
    });

    // ===== EXPORT =====
    const buffer = await wb.xlsx.writeBuffer();
    saveAs(
      new Blob([buffer]),
      `รายงานกระแสเงินสดรับ - จ่าย ${format_date(new Date(year, month - 1), "mmmm yyyy", "th")}.xlsx`,
    );
  };
  imageUrlToBase64 = async (url) => {
    const res = await fetch(url);
    const blob = await res.blob();

    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };
  printPDF = async (type) => {
    const {
      prev_balance_bank,
      prev_balance_cash,
      income_received,
      other_income,
      deduction_amount,
      expense_amount,
      bank_deposit_balance,
      cash_deposit_balance,
      outstanding_debt,
      year,
      month,
    } = this.state;
    if (type === "table") {
      report_cash_flow_report_table(
        {
          prev_balance_bank,
          prev_balance_cash,
          income_received,
          other_income,
          deduction_amount,
          expense_amount,
          bank_deposit_balance,
          cash_deposit_balance,
          outstanding_debt,
          year,
          month,
        },
        title_data,
      );
    } else {
      const convertImage = async (obj) => ({
        ...obj,
        data: await Promise.all(
          (obj?.data || []).map(async (item) => ({
            ...item,
            image: item.image
              ? await this.imageUrlToBase64(item.image)
              : item.image,
          })),
        ),
      });

      let _prev_balance_bank = await convertImage(prev_balance_bank);
      let _prev_balance_cash = await convertImage(prev_balance_cash);
      let _income_received = await convertImage(income_received);
      let _other_income = await convertImage(other_income);
      let _deduction_amount = await convertImage(deduction_amount);
      let _expense_amount = await convertImage(expense_amount);
      let _bank_deposit_balance = await convertImage(bank_deposit_balance);
      let _cash_deposit_balance = await convertImage(cash_deposit_balance);
      let _outstanding_debt = await convertImage(outstanding_debt);

      report_cash_flow_report_full(
        {
          prev_balance_bank: _prev_balance_bank,
          prev_balance_cash: _prev_balance_cash,
          income_received: _income_received,
          other_income: _other_income,
          deduction_amount: _deduction_amount,
          expense_amount: _expense_amount,
          bank_deposit_balance: _bank_deposit_balance,
          cash_deposit_balance: _cash_deposit_balance,
          outstanding_debt: _outstanding_debt,
          year,
          month,
        },
        title_data,
      );
    }
  };
  renderExcel = async (input) => {
    let buffer;

    // 🔥 1. check เป็น base64
    if (input.startsWith("data:")) {
      const pureBase64 = input.split(",")[1];
      const binary = atob(pureBase64);

      const len = binary.length;
      buffer = new ArrayBuffer(len);
      const view = new Uint8Array(buffer);

      for (let i = 0; i < len; i++) {
        view[i] = binary.charCodeAt(i);
      }
    }
    // 🔥 2. เป็น URL
    else {
      const res = await fetch(input, {
        method: "GET",
        mode: "cors",
      });
      buffer = await res.arrayBuffer();
    }

    // 🔥 อ่าน excel
    const workbook = XLSX.read(buffer, { type: "array" });

    const sheet = workbook.Sheets[workbook.SheetNames[0]];

    const data = XLSX.utils.sheet_to_json(sheet, { header: 1 });

    const merges = sheet["!merges"] || [];

    return { data, merges };
  };
  renderTable = ({ data, merges }) => {
    // map สำหรับ merge
    const mergeMap = {};

    merges.forEach((m) => {
      const key = `${m.s.r}-${m.s.c}`;
      mergeMap[key] = {
        rowspan: m.e.r - m.s.r + 1,
        colspan: m.e.c - m.s.c + 1,
      };

      // mark cell ที่ต้อง skip
      for (let r = m.s.r; r <= m.e.r; r++) {
        for (let c = m.s.c; c <= m.e.c; c++) {
          if (r === m.s.r && c === m.s.c) continue;
          mergeMap[`${r}-${c}`] = "skip";
        }
      }
    });

    return (
      <div className="table-responsive">
        <table className="table table-bordered bg-white" width="100%">
          <tbody>
            {data.map((row, r) => (
              <tr key={r}>
                {row.map((cell, c) => {
                  const key = `${r}-${c}`;

                  if (mergeMap[key] === "skip") return null;

                  const merge = mergeMap[key];

                  return (
                    <td
                      key={c}
                      rowSpan={merge?.rowspan || 1}
                      colSpan={merge?.colspan || 1}
                      className="text-nowrap"
                    >
                      {cell}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  onDragEnd = (result) => {
    const { destination, source } = result;
    if (!destination) return;
    if (destination.index === source.index) return;

    const dataName = source.droppableId; // ดึงชื่อ key เช่น 'expense_amount'
    const dataCopy = { ...this.state[dataName] };
    const items = Array.from(dataCopy.data);

    // สลับตำแหน่งใน Array
    const [reorderedItem] = items.splice(source.index, 1);
    items.splice(destination.index, 0, reorderedItem);

    dataCopy.data = items;
    this.setState({ [dataName]: dataCopy });
  };
  isListRow = (item) =>
    Array.isArray(item?.title) && item.title.some((t) => t.type === "list");
  getListTitleIndex = (item) =>
    item.title.findIndex((t) => t.type === "list");
  recomputeListRow = (dataCopy, index, listIdx) => {
    const list = dataCopy.data[index].title[listIdx].list;
    dataCopy.data[index].title[listIdx].value = list
      .map((l) => l.value)
      .filter(Boolean)
      .join(", ");
    dataCopy.data[index].amount = list.reduce(
      (s, l) => s + (Number(l.amount) || 0),
      0,
    );
  };
  addListSubItem = (data, index) => {
    let dataCopy = { ...this.state[data] };
    const listIdx = this.getListTitleIndex(dataCopy.data[index]);
    dataCopy.data[index].title[listIdx].list.push({
      value: "",
      amount: 0.0,
      expenses_type_center: "",
      type: "text",
      required: false,
    });
    this.recomputeListRow(dataCopy, index, listIdx);
    this.setState({ [data]: dataCopy });
  };
  removeListSubItem = (data, index, subIdx) => {
    let dataCopy = { ...this.state[data] };
    const listIdx = this.getListTitleIndex(dataCopy.data[index]);
    if (dataCopy.data[index].title[listIdx].list.length <= 1) return;
    dataCopy.data[index].title[listIdx].list.splice(subIdx, 1);
    this.recomputeListRow(dataCopy, index, listIdx);
    this.setState({ [data]: dataCopy });
  };
  render() {
    const {
      modal_detail,
      modal_print,
      modal_expenses,

      data_index,
      image_index,
      image,
      excel,
      pdf,
      data,
      data_expense_type,
      count,
      filter_search,
      tab,
      tab_menu,
      year,
      month,
      report_id,
      income_received,
      other_income,
      deduction_amount,
      expense_amount,
      bank_deposit_balance,
      cash_deposit_balance,
      outstanding_debt,
      prev_balance_bank,
      prev_balance_cash,
      status,
      type,
      expenses_type_center,
      index_expenses,
      index_type,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="รายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย"
        />
        <div className="body px-3 pb-3 pt-0 position-relative">
          <div>
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex">
                <h4 className="fw-bold mb-3 me-3">
                  รายงานกระแสเงินสดรับ - จ่าย
                </h4>
                <div className="d-flex align-items-start">
                  {report_id
                    ? type === "update"
                      ? Status("แก้ไข", "warning")
                      : type === "view"
                        ? Status("ดูข้อมูล", "success")
                        : type === "print"
                          ? Status("พิมพ์", "success")
                          : null
                    : null}
                </div>
              </div>
              {report_id && type !== "" ? (
                <button
                  className="rounded-4 btn btn-outline-success px-3 mb-0"
                  onClick={() =>
                    this.setState(
                      { tab_menu: "สร้าง", report_id: "", type: "" },
                      () => {
                        this.Get();
                      },
                    )
                  }
                >
                  ย้อนกลับ
                </button>
              ) : (
                <div className="d-flex mb-3">
                  <div
                    className="border rounded-4 border-success mb-2 me-2"
                    style={{ padding: 1 }}
                  >
                    <button
                      className={`rounded-4 btn ${
                        tab_menu === "สร้าง"
                          ? "btn-success"
                          : "btn-outline-success border-0"
                      } px-3 mb-0`}
                      onClick={() =>
                        this.setState(
                          {
                            tab_menu: "สร้าง",
                            tab: "ยอดที่ยกมา",
                            report_id: "",
                          },
                          () => {
                            this.Get();
                          },
                        )
                      }
                    >
                      สร้าง
                    </button>
                    <button
                      className={`rounded-4 btn ${
                        tab_menu === "รายการ"
                          ? "btn-success"
                          : "btn-outline-success border-0"
                      } px-3 mb-0`}
                      onClick={() =>
                        this.setState({ tab_menu: "รายการ", report_id: "" })
                      }
                    >
                      รายงานประจำเดือนทั้งหมด
                    </button>
                  </div>
                </div>
              )}
            </div>
            <hr />
            {tab_menu === "สร้าง" && (
              <div>
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <h3 className="fw-bold d-flex">
                    {stripJuristic(project?.project_name) || "ผู้ดูแลระบบ"}{" "}
                    {format_date(new Date(year, month - 1), "mmmm yyyy", "th")}
                    {data?.filter((e) => e.status !== "cancel").length ===
                      0 && (
                      <input
                        type="month"
                        className="form-control wpx-200 ms-3"
                        onChange={(e) => {
                          this.setState(
                            {
                              year: e.target.value
                                ? Number(e.target.value.split("-")[0])
                                : null,
                              month: e.target.value
                                ? Number(e.target.value.split("-")[1])
                                : null,
                            },
                            () => {
                              this.Get();
                            },
                          );
                        }}
                        value={
                          year
                            ? format_date(
                                new Date(year, month - 1),
                                "yyyy-mm",
                                "en",
                              )
                            : ""
                        }
                      />
                    )}
                  </h3>
                  <div className="d-flex mb-3">
                    <div
                      className="border rounded-4 border-success"
                      style={{ padding: 1 }}
                    >
                      <button
                        className={`rounded-4 btn ${
                          tab === "ยอดที่ยกมา"
                            ? "btn-success"
                            : "btn-outline-success border-0"
                        } px-3 mb-0`}
                        onClick={() => this.setState({ tab: "ยอดที่ยกมา" })}
                      >
                        บันทึกยอดยกมา
                      </button>
                      <button
                        className={`rounded-4 btn ${
                          tab === "กระแสเงินสด"
                            ? "btn-success"
                            : "btn-outline-success border-0"
                        } px-3 mb-0`}
                        onClick={() => this.setState({ tab: "กระแสเงินสด" })}
                      >
                        บันทึกกระแสเงินสด
                      </button>
                    </div>
                  </div>
                </div>
                <div className="pb-5 mb-5">
                  {tab === "ยอดที่ยกมา" ? (
                    <div>
                      {/* DATA */}
                      {["prev_balance_bank", "prev_balance_cash"].map(
                        (data, data_index) =>
                          this.componentTable(data, data_index),
                      )}
                      <div className="d-flex align-items-center justify-content-between w-100 py-2 bg-primary-light fw-bold px-3 mb-3 rounded-4">
                        <span className="text-18">
                          รวมยอดเงินฝากธนาคาร เงินสดคงเหลือในมือ และอื่นๆ ยกมา
                        </span>
                        {/* 1,000.00 ผลรวมของ 2 ยอดบน */}
                        <span className="text-24">
                          {toFixed(
                            total(prev_balance_bank?.data, "amount") +
                              total(prev_balance_cash?.data, "amount"),
                          )}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {/* DATA */}
                      {[
                        "income_received",
                        "other_income",
                        "deduction_amount",
                      ].map((data, data_index) =>
                        this.componentTable(data, data_index),
                      )}
                      <div className="d-flex align-items-center justify-content-between w-100 py-2 bg-primary-light fw-bold px-3 mb-3 rounded-4">
                        <span className="text-18">
                          รวมรับเงินและนำฝากประจำเดือน{" "}
                          {format_date(
                            new Date(year, month - 1),
                            "mmmm yyyy",
                            "th",
                          )}
                        </span>
                        {/* 1,000.00 ผลรวม ทั้ง 3 */}
                        <span className="text-24">
                          {toFixed(
                            total(income_received?.data, "amount") +
                              total(other_income?.data, "amount") +
                              total(deduction_amount?.data, "amount"),
                          )}
                        </span>
                      </div>
                      {["expense_amount"].map((data, data_index) =>
                        this.componentTable(data, data_index),
                      )}
                      <div className="d-flex align-items-center justify-content-between w-100 py-2 bg-primary-light fw-bold px-3 mb-3 rounded-4">
                        <span className="text-18">
                          ประจำเดือน{" "}
                          {format_date(
                            new Date(year, month - 1),
                            "mmmm yyyy",
                            "th",
                          )}{" "}
                          รายการรับเงิน{" "}
                          {total(income_received?.data, "amount") +
                            total(other_income?.data, "amount") +
                            total(deduction_amount?.data, "amount") +
                            total(expense_amount?.data, "amount") <
                          0
                            ? "น้อยกว่า"
                            : "มากกว่า"}{" "}
                          รายการจ่ายเงิน
                        </span>
                        {/* 1,000.00 ผลรวม ทั้ง 4 */}
                        <span
                          className={
                            "text-24" +
                            (total(income_received?.data, "amount") +
                              total(other_income?.data, "amount") +
                              total(deduction_amount?.data, "amount") +
                              total(expense_amount?.data, "amount") <
                            0
                              ? " text-danger"
                              : "")
                          }
                        >
                          {toFixed(
                            total(income_received?.data, "amount") +
                              total(other_income?.data, "amount") +
                              total(deduction_amount?.data, "amount") +
                              total(expense_amount?.data, "amount"),
                          )}
                        </span>
                      </div>
                      <div className="d-flex align-items-center justify-content-between w-100 py-2 bg-primary-light fw-bold px-3 mb-3 rounded-4">
                        <span className="text-18">
                          รวมรายการรับเงิน{" "}
                          {total(income_received?.data, "amount") +
                            total(other_income?.data, "amount") +
                            total(deduction_amount?.data, "amount") +
                            total(expense_amount?.data, "amount") +
                            total(prev_balance_bank?.data, "amount") +
                            total(prev_balance_cash?.data, "amount") <
                          0
                            ? "น้อยกว่า"
                            : "มากกว่า"}{" "}
                          รายการจ่ายเงินสะสม
                        </span>
                        {/* 1,000.00 ผลรวม ทั้ง 4 + ยอดยกมาทั้งหมด  */}
                        <span
                          className={
                            "text-24" +
                            (total(income_received?.data, "amount") +
                              total(other_income?.data, "amount") +
                              total(deduction_amount?.data, "amount") +
                              total(expense_amount?.data, "amount") +
                              total(prev_balance_bank?.data, "amount") +
                              total(prev_balance_cash?.data, "amount") <
                            0
                              ? " text-danger"
                              : "")
                          }
                        >
                          {toFixed(
                            total(income_received?.data, "amount") +
                              total(other_income?.data, "amount") +
                              total(deduction_amount?.data, "amount") +
                              total(expense_amount?.data, "amount") +
                              total(prev_balance_bank?.data, "amount") +
                              total(prev_balance_cash?.data, "amount"),
                          )}
                        </span>
                      </div>
                      {["bank_deposit_balance", "cash_deposit_balance"].map(
                        (data, data_index) =>
                          this.componentTable(data, data_index),
                      )}
                      <div className="d-flex align-items-center justify-content-between w-100 py-2 bg-primary-light fw-bold px-3 mb-3 rounded-4">
                        <span className="text-18">
                          รวมยอดเงินฝากธนาคาร เงินสดคงเหลือในมือและอื่นๆ ยกไป
                        </span>
                        {/* 1,000.00 ผลรวม ของ 2 ข้อ บน */}
                        <span className="text-24">
                          {toFixed(
                            total(bank_deposit_balance?.data, "amount") +
                              total(cash_deposit_balance?.data, "amount"),
                          )}
                        </span>
                      </div>
                      {/* TOTAL */}
                      {/* 1,000.00 ผลรวมของ 2 ยอดบน */}
                      {/* <div className="d-flex align-items-center justify-content-between w-100 py-2 bg-primary-light fw-bold px-3 mb-3 rounded-4">
                        <span className="text-18">
                          ประจำเดือน{" "}
                          {format_date(
                            new Date(year, month - 1),
                            "mmmm yyyy",
                            "th"
                          )}{" "}
                          รายการรับเงิน มากกว่า รายการจ่ายเงิน
                        </span>
                        <span className="text-24">
                          {toFixed(
                            total(income_received?.data, "amount") +
                              total(other_income?.data, "amount") +
                              total(deduction_amount?.data, "amount") +
                              total(expense_amount?.data, "amount") +
                              total(bank_deposit_balance?.data, "amount") +
                              total(cash_deposit_balance?.data, "amount") +
                              total(prev_balance_bank?.data, "amount") +
                              total(prev_balance_cash?.data, "amount")
                          )}
                        </span>
                      </div> */}
                      {/* DIFF */}
                      <div className="d-flex align-items-center justify-content-between w-100 py-2 bg-primary-light fw-bold px-3 mb-3 rounded-4">
                        <span className="text-18">ส่วนต่างยอดปิดบัญชี</span>
                        {/* 1,000.00 ผลรวมของ 2 ยอดบน */}
                        <span
                          className={
                            "text-24" +
                            (total(income_received?.data, "amount") +
                              total(other_income?.data, "amount") +
                              total(deduction_amount?.data, "amount") +
                              total(expense_amount?.data, "amount") +
                              total(prev_balance_bank?.data, "amount") +
                              total(prev_balance_cash?.data, "amount") -
                              (total(bank_deposit_balance?.data, "amount") +
                                total(cash_deposit_balance?.data, "amount")) !==
                            0
                              ? " text-danger"
                              : "")
                          }
                        >
                          {toFixed(
                            total(income_received?.data, "amount") +
                              total(other_income?.data, "amount") +
                              total(deduction_amount?.data, "amount") +
                              total(expense_amount?.data, "amount") +
                              total(prev_balance_bank?.data, "amount") +
                              total(prev_balance_cash?.data, "amount") -
                              (total(bank_deposit_balance?.data, "amount") +
                                total(cash_deposit_balance?.data, "amount")),
                          )}
                        </span>
                      </div>
                      {["outstanding_debt"].map((data, data_index) =>
                        this.componentTable(data, data_index),
                      )}
                    </div>
                  )}
                </div>
                {(status === "pending" ||
                  ["super_user", "admin", "accounting"].includes(
                    profile?.user_type,
                  ) ||
                  type === "print") && (
                  <div
                    className="position-fixed w-100 bg-white p-3 d-flex justify-content-end shadow"
                    style={{ bottom: 0, right: 0, zIndex: 10 }}
                  >
                    {type === "print" ? (
                      <div className="d-flex">
                        <button
                          className="btn btn-success ms-2 px-4"
                          onClick={() => {
                            this.exportExcel();
                          }}
                        >
                          พิมพ์ Excel
                        </button>
                        <button
                          className="btn btn-success ms-2 px-4"
                          onClick={() => {
                            this.printPDF("table");
                          }}
                        >
                          พิมพ์ PDF ตาราง
                        </button>
                        <button
                          className="btn btn-success ms-2 px-4"
                          onClick={() => {
                            this.printPDF("full");
                          }}
                        >
                          พิมพ์ PDF รายละเอียด
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex">
                        {profile?.user_type === "super_user" ? (
                          <div className="d-flex me-5">
                            <button
                              className="btn btn-primary px-5 ms-1"
                              onClick={() => {
                                Swal.fire({
                                  icon: "info",
                                  title: "ยืนยันการอนุมัติ",
                                  text: "ยืนยันการอนุมัติรายการนี้หรือไม่ ?",
                                  showCancelButton: true,
                                  confirmButtonText: "อนุมัติ",
                                  cancelButtonText: "ยกเลิก",
                                }).then((result) => {
                                  if (result.isConfirmed) {
                                    this.CreateUpdate("approved");
                                  }
                                });
                              }}
                            >
                              อนุมัติ
                            </button>
                          </div>
                        ) : (
                          <div />
                        )}
                        <div className="d-flex">
                          <button
                            className="btn btn-danger px-5 me-1"
                            onClick={() => {
                              this.setState({ data: [] });
                            }}
                          >
                            ล้างข้อมูล
                          </button>
                          <button
                            className="btn btn-success px-5 ms-1"
                            onClick={() => {
                              this.CreateUpdate("pending");
                            }}
                          >
                            บันทึก
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
            {tab_menu === "รายการ" && (
              <div>
                <div className="d-flex align-items-center flex-wrap">
                  <input
                    type="text"
                    className="form-control wpx-250 me-2 mb-2"
                    placeholder="ค้นหา..."
                    onChange={(e) => {
                      this.setState({ filter_search: e.target.value });
                    }}
                    value={filter_search}
                  />
                  <div className="d-flex">
                    <button
                      className="btn btn-success px-4 me-2 mb-2"
                      onClick={() => {
                        this.Get(1);
                      }}
                    >
                      ค้นหา
                    </button>
                    <button
                      className="btn btn-outline-success px-4 me-2 mb-2"
                      onClick={() => {
                        window.location.reload();
                      }}
                    >
                      ล้างค่า
                    </button>
                  </div>
                </div>
                <div className="card rounded border-0 overflow-hidden">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0">
                      <thead className="bg-light text-secondary">
                        <tr>
                          <th className="wpx-50 text-center">ลำดับ</th>
                          <th>เดือน/ปี</th>
                          <th className="wpx-150 text-center">สถานะ</th>
                          <th>หมายเหตุ</th>
                          <th className="text-center wpx-90">จัดการ</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.map((item, index) => (
                          <tr key={"table_" + index}>
                            <td className="text-center">{index + 1}</td>
                            <td>
                              {format_date(
                                new Date(item.year, item.month - 1),
                                "mmmm yyyy",
                              )}
                            </td>
                            <td>
                              <div className="d-flex justify-content-center">
                                {Status(
                                  {
                                    pending: "รออนุมัติ",
                                    approved: "อนุมัติ",
                                    cancel: "ยกเลิก",
                                  }[item.status],
                                  {
                                    pending: "warning",
                                    approved: "success",
                                    cancel: "danger",
                                  }[item.status],
                                )}
                              </div>
                            </td>
                            <td>{item.remark || ""}</td>
                            <td className="py-1">
                              <div className="d-flex justify-content-center">
                                {/* <BtnIcon
                                  type="csv"
                                  onClick={async () => {
                                    await this.GetByID(item.report_id);
                                    this.exportExcel();
                                  }}
                                /> */}
                                <BtnIcon
                                  type="print"
                                  onClick={async () => {
                                    await this.GetByID(item.report_id);
                                    this.setState({
                                      type: "print",
                                      tab_menu: "สร้าง",
                                      tab: "ยอดที่ยกมา",
                                    });
                                    title_data = {
                                      prev_balance_bank: {
                                        title:
                                          "สรุปยอดบัญชีเงินฝากธนาคารและเงินสดคงเหลือในมือยกมา ณ​ " +
                                          format_date(
                                            new Date(year, month - 1, 0),
                                            "dd mmmm yyyy",
                                            "th",
                                          ),
                                        creatable: true,
                                        selected: true,
                                      },
                                      prev_balance_cash: {
                                        title:
                                          "รายการเงินสดคงเหลือในมือและอื่นๆ ณ​ " +
                                          format_date(
                                            new Date(year, month - 1, 0),
                                            "dd mmmm yyyy",
                                            "th",
                                          ),
                                        creatable: true,
                                        selected: true,
                                      },

                                      income_received: {
                                        title: "รายการรับเงิน",
                                        creatable: true,
                                        selected: true,
                                      },
                                      other_income: {
                                        title: "รายรับอื่นๆ",
                                        creatable: true,
                                        selected: true,
                                      },
                                      deduction_amount: {
                                        title: "หัก/เพิ่ม/ลดหนี้",
                                        creatable: true,
                                        selected: true,
                                      },
                                      expense_amount: {
                                        title: "รายการจ่ายเงิน",
                                        creatable: true,
                                        selected: true,
                                      },
                                      bank_deposit_balance: {
                                        title:
                                          `ยอดเงินฝากธนาคาร ${project?.project_name || "ผู้ดูแลระบบ"} ณ​ ` +
                                          format_date(
                                            new Date(year, month, 0),
                                            "dd mmmm yyyy",
                                            "th",
                                          ),
                                        creatable: true,
                                        selected: true,
                                      },
                                      cash_deposit_balance: {
                                        title:
                                          "รายการเงินสดคงเหลือในมือและอื่นๆ ณ​ " +
                                          format_date(
                                            new Date(year, month, 0),
                                            "dd mmmm yyyy",
                                            "th",
                                          ),
                                        creatable: true,
                                        selected: true,
                                      },
                                      outstanding_debt: {
                                        title:
                                          "หนี้คงค้าง ณ สิ้นสุด ประจำเดือน " +
                                          format_date(
                                            new Date(year, month, 0),
                                            "mmmm yyyy",
                                            "th",
                                          ),
                                        creatable: true,
                                        selected: true,
                                      },
                                    };
                                  }}
                                />
                                {item.status !== "cancel" && (
                                  <BtnIcon
                                    type="update"
                                    onClick={async () => {
                                      await this.GetByID(item.report_id);
                                      this.setState({
                                        type: "update",
                                        tab_menu: "สร้าง",
                                        tab: "ยอดที่ยกมา",
                                      });
                                    }}
                                  />
                                )}
                                {item.status !== "pending" && (
                                  <BtnIcon
                                    type="view"
                                    onClick={async () => {
                                      await this.GetByID(item.report_id);
                                      this.setState({
                                        type: "view",
                                        tab_menu: "สร้าง",
                                        tab: "ยอดที่ยกมา",
                                      });
                                    }}
                                  />
                                )}
                                {data.filter((e) => e.status !== "cancel")[0]
                                  ?.report_id === item.report_id && (
                                  <BtnIcon
                                    type="delete"
                                    onClick={() => {
                                      this.Delete(item.report_id);
                                    }}
                                  />
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="w-100 d-flex align-items-center justify-content-between p-3">
                  {/* ★ Get() ดึงรายงานทั้งหมดก้อนเดียว (ไม่ส่ง page) API จึงไม่คืน count → เดิมขึ้น "ทั้งหมด  รายการ"
                      ตารางแสดงทุกแถวของ data อยู่แล้ว ใช้จำนวนแถวที่แสดงจริงแทน */}
                  <small>ทั้งหมด {count ?? data?.length ?? 0} รายการ</small>
                  <Pagination
                    count={Math.ceil(count / 10)}
                    showFirstButton
                    showLastButton
                    onChange={(_, page) => {
                      this.Get(page);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        {/* VIEW */}
        <Modal
          show={modal_detail}
          size="lg"
          className="rounded-3"
          onHide={() => {
            this.setState({ modal_detail: false });
          }}
        >
          <Modal.Body className="p-0 rounded-top-3">
            <div className="w-100 d-flex justify-content-center bg-secondary-light rounded-top-3">
              {image && (
                <img
                  className="w-100 img-fluid rounded-top-3"
                  src={image}
                  alt="slip"
                  style={{ objectFit: "contain" }}
                />
              )}
              {excel && this.renderTable(excel)}
              {pdf && (
                <iframe
                  src={pdf} // 👈 ใช้ base64 ได้เลย
                  width="100%"
                  height="600px"
                  style={{ border: "none" }}
                  title="PDF Viewer"
                />
              )}
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between py-1">
            {!["view", "print"].includes(type) && (
              <BtnIcon
                type="delete"
                onClick={async () => {
                  if (
                    await alert(
                      "",
                      "info",
                      "ยืนยัน",
                      "ยืนยันการลบข้อมูลนี้หรือไม่?",
                      "ลบข้อมูล",
                      "ยกเลิก",
                    )
                  ) {
                    const dataCopy = { ...this.state[data_index] };
                    if (image) {
                      dataCopy.data[image_index].image = "";
                    }
                    if (excel) {
                      dataCopy.data[image_index].excel = "";
                    }
                    if (pdf) {
                      dataCopy.data[image_index].pdf = "";
                    }
                    this.setState({
                      [data_index]: dataCopy,
                      modal_detail: false,
                    });
                  }
                }}
              />
            )}
            <div />
            <button
              className="btn btn-outline-danger px-5"
              onClick={() => {
                this.setState({ modal_detail: false });
              }}
            >
              ปิดหน้าต่าง
            </button>
          </Modal.Footer>
        </Modal>

        {/* EXPENSES */}
        <Modal
          show={modal_expenses}
          onHide={() =>
            this.setState({ modal_expenses: false, index_sub: -1 })
          }
        >
          <Modal.Header closeButton>
            <h5 className="fw-bold mb-0">
              เลือกค่าใช้จ่ายกลางสำหรับ ครั้งที่{" "}
              {title_data[index_expenses]?.title || ""} ลำดับที่{" "}
              {index_expenses + 1}
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex mb-2">
              <div className="wpx-100 mt-2">ค่าใช้จ่ายกลาง</div>
              <select
                className="form-control"
                onChange={(e) => {
                  this.setState({ expenses_type_center: e.target.value });
                }}
                value={expenses_type_center}
              >
                <option value="">เลือกค่าใช้จ่ายกลาง</option>
                {data_expense_type.map((e) => (
                  <option value={e.value}>{e.label}</option>
                ))}
              </select>
            </div>
          </Modal.Body>
          <Modal.Footer className="py-1">
            <div className="d-flex justify-content-end">
              <button
                className="btn btn-success px-4 me-1"
                onClick={() => {
                  let data = this.state[index_type];
                  const { index_sub } = this.state;
                  if (index_sub > -1) {
                    const listIdx = this.getListTitleIndex(
                      data.data[index_expenses],
                    );
                    data.data[index_expenses].title[listIdx].list[
                      index_sub
                    ].expenses_type_center = expenses_type_center;
                  } else {
                    data.data[index_expenses].expenses_type_center =
                      expenses_type_center;
                  }
                  this.setState({
                    modal_expenses: false,
                    [index_type]: data,
                    index_sub: -1,
                  });
                }}
              >
                บันทึก
              </button>
              <button
                className="btn btn-danger px-4 ms-1"
                onClick={() => {
                  this.setState({ modal_expenses: false, index_sub: -1 });
                }}
              >
                ยกเลิก
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
